module.exports = __webpack_public_path__ + "static/img/img20.567e8c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img20.png
// module id = mKk1
// module chunks = 1